import styled from "styled-components";

export const PaymentInitializerContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
`
export const CheckoutBtnContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 20px;
    justify-content: center;
    padding-top: 30px;
    padding-bottom: 30px;
    width: 400px;
`